import { useState, useEffect } from "react";
import { Tab, Tabs } from "@mui/material";
import Markdown from "markdown-to-jsx";
import Modal from "../../Component/Modal/Modal";
import classes from "../../Component/BaseResponseComponent/BaseResponseModal.module.css";

/**
 * A modal with optional LLM tabs at the top.
 * Used in CategoryAnalysis composite (By LLM) mode for Brand Pillars and Purchase Criteria base responses.
 *
 * Props:
 *   open: boolean
 *   onClose: () => void
 *   title: string
 *   tabs: Array<{ label: string, content: string }> — if only 1 tab, no tab bar is shown
 */
export default function CATabbedModal({ open, onClose, title, tabs = [] }) {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (open) setActiveTab(0);
  }, [open, title]);

  if (!open) return null;

  const singleTab = tabs.length <= 1;
  const activeContent = tabs[singleTab ? 0 : activeTab]?.content || "";

  return (
    <Modal open={open} handleClose={onClose} title={title} width={800}>
      {!singleTab && (
        <Tabs
          value={activeTab}
          onChange={(_, i) => setActiveTab(i)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            mb: 2,
            borderBottom: "2px solid #e8edf7",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.84rem",
              minHeight: 40,
              padding: "6px 20px",
              color: "#6b7a9d",
            },
            "& .Mui-selected": { color: "#4361ee" },
            "& .MuiTabs-indicator": {
              backgroundColor: "#4361ee",
              height: 3,
              borderRadius: "3px 3px 0 0",
            },
          }}
        >
          {tabs.map((tab, i) => (
            <Tab key={i} label={tab.label} />
          ))}
        </Tabs>
      )}
      <div className={classes.info_modal_content}>
        <Markdown>{activeContent}</Markdown>
      </div>
    </Modal>
  );
}
